"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
exports.__esModule = true;
exports.NodeDefIdentifierEvaluator = void 0;
var survey_1 = require("../../../survey");
var nodeDefs_1 = require("../../nodeDefs");
var utils_1 = require("../../../utils");
var identifier_1 = require("../../../expression/javascript/node/identifier");
var findActualContextNode = function (params) {
    var context = params.context;
    var survey = context.survey, nodeDefContext = context.nodeDefContext;
    if (!nodeDefContext)
        return undefined;
    if (nodeDefs_1.NodeDefs.isAttribute(nodeDefContext)) {
        return survey_1.Surveys.getNodeDefParent({ survey: survey, nodeDef: nodeDefContext });
    }
    if (nodeDefContext.virtual) {
        return survey_1.Surveys.getNodeDefSource({ survey: survey, nodeDef: nodeDefContext });
    }
    return nodeDefContext;
};
var getReachableNodeDefs = function (params) {
    var context = params.context;
    var survey = context.survey;
    var reachableNodeDefs = [];
    var queue = new utils_1.Queue();
    var visitedUuids = [];
    var actualContextNode = findActualContextNode({ context: context });
    if (actualContextNode)
        queue.enqueue(actualContextNode);
    while (!queue.isEmpty()) {
        var entityDefCurrent = queue.dequeue();
        var entityDefCurrentChildren = survey_1.Surveys.getNodeDefChildren({ survey: survey, nodeDef: entityDefCurrent });
        reachableNodeDefs.push.apply(reachableNodeDefs, __spreadArray([entityDefCurrent], entityDefCurrentChildren, false));
        queue.enqueueItems(entityDefCurrentChildren.filter(nodeDefs_1.NodeDefs.isSingleEntity));
        if (!visitedUuids.includes(entityDefCurrent.uuid)) {
            var entityDefCurrentParent = survey_1.Surveys.getNodeDefParent({ survey: survey, nodeDef: entityDefCurrent });
            if (entityDefCurrentParent) {
                queue.enqueue(entityDefCurrentParent);
            }
            visitedUuids.push(entityDefCurrent.uuid);
        }
    }
    return reachableNodeDefs;
};
var findIdentifierAmongReachableNodeDefs = function (params) {
    var context = params.context, expressionNode = params.expressionNode;
    var nodeDefContext = context.nodeDefContext;
    if (nodeDefContext) {
        var reachableNodeDefs = getReachableNodeDefs({ context: context });
        return reachableNodeDefs.find(function (reachableNodeDef) { return reachableNodeDef.props.name === expressionNode.name; });
    }
    return undefined;
};
var NodeDefIdentifierEvaluator = (function (_super) {
    __extends(NodeDefIdentifierEvaluator, _super);
    function NodeDefIdentifierEvaluator() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    NodeDefIdentifierEvaluator.prototype.evaluate = function (expressionNode) {
        try {
            return _super.prototype.evaluate.call(this, expressionNode);
        }
        catch (e) {
            return findIdentifierAmongReachableNodeDefs({ context: this.context, expressionNode: expressionNode });
        }
    };
    return NodeDefIdentifierEvaluator;
}(identifier_1.IdentifierEvaluator));
exports.NodeDefIdentifierEvaluator = NodeDefIdentifierEvaluator;
//# sourceMappingURL=identifier.js.map